import { Button, Divider, Flex, Form, Input } from 'antd';
import { FC } from 'react';

interface Props {
  search: string | undefined;
  handleSubmitSearch: (v: string | undefined) => void;
}

type Searching = {
  search: string | undefined;
}

export const CloudflareAccountsSearchingForm: FC<Props> = ({ search, handleSubmitSearch }) => {
  const [form] = Form.useForm<Searching>();

  const anyWatch = Form.useWatch((v) => v, form);

  const initialValues: Searching = { search };

  const handleFinish = (values: Searching) => {
    handleSubmitSearch(values.search);
  };

  const handleReset = () => {
    form.setFieldValue('search', undefined);
    handleSubmitSearch(undefined);
  };

  const formEnabled = !!anyWatch?.search;

  return (
    <Form
      form={ form }
      autoComplete="off"
      name="searching-cloudflare-accounts"
      layout="inline"
      initialValues={ initialValues }
      onFinish={ handleFinish }
      onReset={ handleReset }
    >
      { formEnabled && (
        <Flex align="center">
          <Form.Item noStyle>
            <Button htmlType="reset" danger>
              Скинути
            </Button>
          </Form.Item>
          <Divider type="vertical" style={{ height: '2em' }}/>
        </Flex>
      ) }

      <Form.Item name="search" noStyle>
        <Input.Search
          style={{ width: 330 }}
          placeholder="Пошук Cloudflare акаунтів"
          enterButton={ formEnabled }
          onSearch={ (search) => handleFinish({ search }) }
        />
      </Form.Item>
    </Form>
  );
};
